import React, { useState } from 'react';
interface ToggleProps {
  enabled?: boolean;
  onChange?: (value: boolean) => void;
}
export const Toggle = ({
  enabled: initialEnabled = true,
  onChange
}: ToggleProps) => {
  const [enabled, setEnabled] = useState(initialEnabled);
  const handleToggle = () => {
    const newValue = !enabled;
    setEnabled(newValue);
    onChange?.(newValue);
  };
  return <button onClick={handleToggle} className={`relative inline-flex h-6 w-11 items-center rounded-full ${enabled ? 'bg-blue-600' : 'bg-gray-200'}`} data-id="element-218">
      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${enabled ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-219" />
    </button>;
};